export function qs(root, selector) {
  return root.querySelector(selector);
}

export function qsa(root, selector) {
  return Array.from(root.querySelectorAll(selector));
}

export function clear(el) {
  el.replaceChildren();
}

export function setText(el, text) {
  el.textContent = text == null ? '' : String(text);
}

export function el(tagName, attrs = {}, children = []) {
  const node = document.createElement(tagName);

  for (const [key, value] of Object.entries(attrs)) {
    if (value == null) continue;
    if (key === 'class') node.className = value;
    else if (key === 'dataset') Object.assign(node.dataset, value);
    else if (key === 'text') node.textContent = String(value);
    else node.setAttribute(key, String(value));
  }

  for (const child of children) {
    if (child == null) continue;
    if (typeof child === 'string') node.appendChild(document.createTextNode(child));
    else node.appendChild(child);
  }

  return node;
}

